// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1LjYq","additionalInfo":"AgreementModal_additionalInfo__mLnxL"};